export default __webpack_public_path__ + "static/media/NIAS0560.34I-40205_-23873_0.6640c6a8.jpg";